let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9F2Zb")).then(() => parcelRequire('7Y168'));